jQuery(function ($) {
    $('#header-menu > .menu-item.menu-item-has-children').on('click', function (evt) {
        $(this).children('.sub-menu').slideToggle();
    });

    $('#header-menu > .menu-item.menu-item-has-children a').on('click', function (evt) {
        evt.stopPropagation();
    });

    $('#menu-categorias .list-group .list-group-item:has(.menu-item-has-children):not(a)').on('click', function(e){
        let $this = $(this);        
        $('#menu-categorias .menu-item-has-children ul:visible').slideToggle();
        $this.children('.menu-item-has-children ul').slideToggle();        
    });
    
    $('#menu-categorias .list-group .list-group-item a').on('click', function(evt){
        evt.stopPropagation();     
    });

    $('.slide-banner').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        autoplay: true,
        autoplaySpeed: 8000,        
        fade: true,
        prevArrow: '<button type="button" class="slick-prev" aria-label="Anterior"><i class="bi bi-chevron-left"></i></button>',
        nextArrow: '<button type="button" class="slick-next" aria-label="Próximo"><i class="bi bi-chevron-right"></i></button>',
        responsive: [
            {
                breakpoint: 580,
                settings: {
                    arrows: false,
                    dots: true
                }
            }
        ]
    });

    $('.carrossel-categorias').slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: '<button type="button" class="slick-prev" aria-label="Anterior"><i class="bi bi-chevron-left"></i></button>',
        nextArrow: '<button type="button" class="slick-next" aria-label="Próximo"><i class="bi bi-chevron-right"></i></button>',
        dots: false,
        autoplay: true,
        autoplaySpeed: 4000,
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 580,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });


    $('.produto-slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        fade: true,
        asNavFor: '.produto-carrossel'
    });   

    $('.produto-carrossel').slick({
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: '.produto-slider',
        arrows: true,
        prevArrow: '<button type="button" class="slick-prev" aria-label="Anterior"><i class="bi bi-chevron-left"></i></button>',
        nextArrow: '<button type="button" class="slick-next" aria-label="Próximo"><i class="bi bi-chevron-right"></i></button>',
        dots: false,
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 580,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });

    $('.carrossel-parceiro').slick({
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: '<button type="button" class="slick-prev" aria-label="Anterior"><i class="bi bi-chevron-left"></i></button>',
        nextArrow: '<button type="button" class="slick-next" aria-label="Próximo"><i class="bi bi-chevron-right"></i></button>',
        dots: false,
        autoplay: true,
        autoplaySpeed: 2000,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 580,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });

    $('.input-group-addcart .btn-rmv').on('click', function (evt) {
        evt.preventDefault();
        let $group = $(this).closest('.input-group-addcart');
        let $input = $group.children('input[name="qty"]');
        let $inputVal = parseInt($input.val()) - 1;
        if ($inputVal >= 1) {
            $input.val($inputVal).trigger("change");
        }
    });

    $('.input-group-addcart .btn-add').on('click', function (evt) {
        evt.preventDefault();
        let $this = $(this);
        let $group = $this.closest('.input-group-addcart');
        let $input = $group.children('input[name="qty"]');
        let $inputVal = parseInt($input.val()) + 1;
        $input.val($inputVal).trigger("change");
    });

    $('form.form-add-cart').on('submit', function (evt) {
        evt.preventDefault();

        let $this = $(this);
        let $payload = $this.serializeArray();
        $payload.push({ name: 'action', value: naitech.action_cart });

        $this.find('button[type="submit"]').prop('disabled', true);
        $this.find('button[type="submit"] .loading').show();

        $.post(naitech.ajax_url, $payload, function (data) {
            if (data.status) {
                $('.cart-items').text(data.items);
                $('#modal-cart .modal-body').html('<p>' + data.message + '</p>');
                $('#modal-cart').modal('show');
            }
            $this.find('button[type="submit"]').prop('disabled', false);
            $this.find('button[type="submit"] .loading').hide();
        }, 'json');

    });

    $('form.form-update-cart').on('change', function (evt) {
        evt.preventDefault();

        let $this = $(this);
        let $payload = $this.serializeArray();
        $payload.push({ name: 'action', value: 'update-cart' });

        $this.children('fieldset').prop('disabled', true);

        $.post(naitech.ajax_url, $payload, function (data) {
            if (data.status) {
                $('.cart-items').text(data.items);
            }
            $this.children('fieldset').prop('disabled', false);
        }, 'json');

    });

    $('.btn-remove-produto').on('click', function (evt) {
        evt.preventDefault();

        let $this = $(this);
        let $pid = $this.attr('data-id');
        let $payload = { pid: $pid, action: 'remove-from-cart' };
        $this.prop('disabled', true);

        if (confirm('Deseja realmente remover este item?')) {

            $.post(naitech.ajax_url, $payload, function (data) {
                if (data.status) {
                    $('.cart-items').text(data.items);
                    $this.closest('tr').remove();
                }
            }, 'json');

        } else {
            $this.prop('disabled', false);
        }

    });

    $('button[data-bs-toggle="tab"]').on('click', function(evt){
        evt.preventDefault();
        let $this = $(this);
        let $tab_current = $('.tab-pane.active');
        let $tab_go = $this.attr('data-bs-target');
        $tab_current.removeClass(['show', 'active']);
        $($tab_go).addClass('show active');
        if($tab_go === '#info-tab'){
            $('#input-quotation-name').focus();
        }
    });

    $('#input-quotation-conheceu').on('change', function(){
        let $this = $(this);
        if($this.val() == 'Outros (especificar)'){
            $('#group-quotation-conheceu-outros').removeClass('visually-hidden');
            $('#input-quotation-conheceu-outros').prop('required', true);
        }else{
            $('#group-quotation-conheceu-outros').addClass('visually-hidden');
            $('#input-quotation-conheceu-outros').prop('required', false);
        }
    });

    

});